import { render, staticRenderFns } from "./map_old.vue?vue&type=template&id=02b83ead&scoped=true&"
import script from "./map_old.vue?vue&type=script&lang=js&"
export * from "./map_old.vue?vue&type=script&lang=js&"
import style0 from "./map_old.vue?vue&type=style&index=0&id=02b83ead&scoped=true&lang=css&"
import style1 from "./map_old.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b83ead",
  null
  
)

/* custom blocks */
import block0 from "./map_old.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Fa.amap.com%2Fjsapi_demos%2Fstatic%2Fdemo-center%2Fcss%2Fdemo-center.css"
if (typeof block0 === 'function') block0(component)

export default component.exports